import React from 'react'
import NavigatePage from './NavigatePage'
import { Route, Routes, useLocation } from 'react-router-dom'
import ProtectedRoute from '../../starter/ProtectedRoute/ProtectedRoute'
import Layout from '../Layout/Layout'
import Header from '../Header/Header'
import LeftPanelMain from '../LeftPanelMain/LeftPanelMain'
import MainView from '../Main/MainView'
import Footer from '../Footer/Footer'
import GanttView from '../GanttView/GanttView'
import Settings from '../Settings/Settings'

import { useGetMyEmployeesQuery } from '../../starter/api/employeesApi'
import { useGetMyProjectsQuery } from '../../starter/api/projectsApi'
import { useGetProjectManagersQuery } from '../../starter/api/projectManagersApi'
import { useGetProjectEmployeeLinksQuery } from '../../starter/api/projectEmployeeLinksApi'
import { useGetSequenceProjectQuery } from '../../starter/api/sequenceProjectApi'
import { Button, Modal, Popconfirm } from 'antd'
import { useAppSelector } from '../../starter/hooks/redux'
import { useActions } from '../../starter/hooks/actions'
const Root = () => {
  const location = useLocation()
  const { onShowModal } = useActions()

  const { title, isShow, content, buttonSet } = useAppSelector((state) => state.modal)
  useGetMyEmployeesQuery()
  useGetMyProjectsQuery()
  useGetProjectManagersQuery()
  useGetProjectEmployeeLinksQuery()
  useGetSequenceProjectQuery()

  return (
    <div>
      <Modal
        title={title}
        open={isShow}
        footer={buttonSet.map((item, index) => {
          if (item.confirm) {
            return (
              <Popconfirm
                key={index}
                title={item.confirm.text}
                description={item.confirm.description}
                onConfirm={item.confirm.onConfirm}
                onCancel={() => {}}
                okText='Да'
                cancelText='Нет'>
                <Button key={index} {...item} />
              </Popconfirm>
            )
          } else {
            return <Button key={index} {...item} />
          }
        })}
        onCancel={() => onShowModal(false)}>
        {content}
      </Modal>
      {location.pathname === '/' && <Layout header={Header} middle={NavigatePage} footer={Footer} />}
      <Routes>
        <Route
          path='/main'
          element={
            <ProtectedRoute
              element={Layout}
              header={Header}
              leftPanel={LeftPanelMain}
              middle={MainView}
              footer={Footer}
            />
          }
        />
        <Route
          path='/gantt'
          element={<ProtectedRoute element={Layout} header={Header} middle={GanttView} footer={Footer} />}
        />
        <Route
          path='/settings'
          element={<ProtectedRoute element={Layout} header={Header} middle={Settings} footer={Footer} />}
        />
      </Routes>
    </div>
  )
}

export default Root
